import {calculateDiscountAmount} from "./TableHelpers/commonHelper";
import { parseDate } from "./dateHelpers";
import {calculateAmountAfterDiscount, isCurrentMonth} from "./filter";

export const getTotalsForTheMonth = monthBasedDataArr => {
    let totalOrders = 0;
    let totalPaidOrders = 0;
    let totalBillingAmount = 0;
    let billedAccountsCount = 0;
    monthBasedDataArr.forEach(billingData => {
        totalOrders += billingData.numberOfOrders;
        totalPaidOrders += billingData.numberOfPaidOrders;
        totalBillingAmount += billingData.billableAmount;
    })
    billedAccountsCount = monthBasedDataArr.reduce((count, item) => {
        return item.billableAmount !== 0 ? count + 1 : count;
    }, 0);
    return {
        totalOrders, totalPaidOrders, totalBillingAmount, billedAccountsCount
    }
}

export const getTotalThirdPartyOrdersByWeek = weekBasedDataArr => {
    let total = 0;
    let totalPaid = 0;
    let outstandingAmount = 0;
    let billedAccountsCount = 0;

    weekBasedDataArr.forEach((data) => {
        total += data.totalAmount;
        totalPaid += data.paidAmount;
        outstandingAmount += data.unpaidAmount;
    });

    total = total.toFixed(2);
    totalPaid = totalPaid.toFixed(2);
    outstandingAmount = outstandingAmount.toFixed(2);
    billedAccountsCount = weekBasedDataArr.length;
    return {
        total, totalPaid, outstandingAmount, billedAccountsCount
    }
}

export const getTotalDueAndSavingForCurrentMonth = (billingDetails, discount) => {
    let targetDate;
    for (let date in billingDetails) {
        targetDate = parseDate(date);
        if (isCurrentMonth(targetDate)) {
            let afterDiscountAmount = calculateAmountAfterDiscount(billingDetails[date].totalBillingAmount, discount);
            let discountedAmount = calculateDiscountAmount(billingDetails[date].totalBillingAmount, discount);
            return {afterDiscountAmount, discountedAmount}
        }
    }
    return {afterDiscountAmount: "0", discountedAmount: "0"}
}

export const getTotalSavingForCurrentYear = (billingDetails, discount) => {
    let currentMonth = new Date();
    let targetDate;
    let totalAmount = 0;
    for (let date in billingDetails) {
        targetDate = new Date(date);
        if (currentMonth.getFullYear() === targetDate.getFullYear()) {
            totalAmount += billingDetails[date].totalBillingAmount;
        }
    }
    return calculateDiscountAmount(totalAmount, discount);
}

export const onlyFirstLetterCapital = (str) => {
    if (str === null || str === "") return "";
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

export const getSubscriptionType = (planText) => {
    switch (planText) {
        case "Starter":
            return "STARTER";
        case "Professional":
            return "PROFESSIONAL_PLUS";
        case "Professional (without sms)":
            return "PROFESSIONAL_PLUS_WITHOUT_SMS";
        case "Branded Premium":
            return "BRANDED_PREMIUM_PLUS";
        case "Branded Premium (without sms)":
            return "BRANDED_PREMIUM_WITHOUT_SMS";
        case "Branded Elite":
            return "BRANDED_ELITE_LITE";
        case "Trial (professional)":
            return "TRIAL_PROFESSIONAL";
        case "Business Advanced":
            return "BUSINESS_ADVANCED";
        case "Business AI":
            return "BUSINESS_AI";
        default:
            return -1;
    }
}

export const checkIfWithoutSMSAvailable = (country) => {
    let excludedList = ["United States", "Canada", "Australia", "United Kingdom"];
    return !excludedList.includes(country);
}
